/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';

export interface SearchPermissionGrantsRequest {
  skip?: number;
  take?: number;
  includeTotalCount?: boolean | null;
  sortExpressions?: Array<SortExpression> | null;
  sourceUserIds?: Array<string> | null;
  destinationUserIds?: Array<string> | null;
  grantDates?: DateTimePeriod;
  permissionIds?: Array<string> | null;
}
